module.exports = __webpack_public_path__ + "media/images/header-corporation-14a5d60b40c96fbc47ba99054b58bbe7.svg";